
<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <div>
    <b-card title="Informations générales">
       <validation-observer ref="simpleRules">
        <b-form
          @submit.prevent
        >
        <b-row>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Nom"
              label-for="basicInput"
            >
            <validation-provider
              #default="{ errors }"
              name="Nom"
              rules="required"
            >
              <b-form-input 
              required
                id="basicInput"
                v-model="form.name"
                :plaintext="readOnly"
                :state="errors.length > 0 ? false:null"
                placeholder="Nom"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Photo"
              label-for="Photo"
            >
            <b-media vertical-align="top" v-if="file!==null">
                  <template #aside>
                    <b-img
                      :src="file"
                      blank-color="#ccc"
                      width="64"
                      alt="placeholder"
                      
                    />
                  </template>
                  
                  <b-card-text class="mb-0">
                
                    <b-button
                    size="sm"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-warning"
                      class="btn-icon"
                      @click="editPhoto()"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </b-card-text>
                </b-media>
            <b-form-file v-else
            required
                v-model="file"
                :state="Boolean(file)"
                placeholder="Choisissez ou faites glisser un fichier..."
                drop-placeholder="Déposer ici ..."
                @change="fileAdded($event)"
            />
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Icone"
              label-for="Icone"
            >
            <b-media vertical-align="top" v-if="file2!==null">
                  <template #aside>
                    <b-img
                      :src="file2"
                      blank-color="#ccc"
                      width="64"
                      alt="placeholder"
                      
                    />
                  </template>
                  
                  <b-card-text class="mb-0">
                
                    <b-button
                    size="sm"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-warning"
                      class="btn-icon"
                      @click="editIcon()"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </b-card-text>
                </b-media>
            <b-form-file v-else
            required
                v-model="file2"
                :state="Boolean(file2)"
                placeholder="Choisissez ou faites glisser un fichier..."
                drop-placeholder="Déposer ici ..."
                @change="fileAdded2($event)"
            />
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Prix"
              label-for="Prix"
            >
            <validation-provider
              #default="{ errors }"
              name="Prix"
              rules="required"
            >
              <b-form-input
              required
                id="Prix"
                v-model="form.price"
                :plaintext="readOnly"
                type="number"
                step="0.01"
                placeholder="Prix"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Type de verre"
              label-for="Type de verre"
            >
             <validation-provider
              #default="{ errors }"
              name="Type de verre"
              rules="required"
            >
              <v-select
                v-model="form.glass_types"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                multiple
                :state="errors.length > 0 ? false:null"
                :options="glassTypeChoices"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Verres transparents seulement"
              label-for="Verres transparents seulement"
            >
              <b-form-checkbox
                v-model="form.transparent_only"
                
                class="custom-control-primary"
              >
                Verres transparents seulement
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <label for="textarea-default">Description</label>
            <b-form-textarea
              v-model="form.description"
              id="textarea-default"
              placeholder="Description"
            
              rows="3"
            />
            </b-col>
        </b-row>
      </b-form>
      </validation-observer>

    </b-card>

    

  <b-button v-if="edition==false"
     @click="createGlassOption"
    >
    Enregistrer
    </b-button>

    <b-button v-else
     @click="updateGlassOption"
    >
    Enregistrer
    </b-button>

  </div>
</b-overlay>
</template>

<script>
import { BButton,BFormInput, BOverlay, BForm, BMedia, BCardText, BImg, BRow, BCol, BFormGroup,BFormFile, BCard, BFormCheckbox, BFormTextarea} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import {APIRequest,Utils} from '@simb2s/senseye-sdk'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'

export default {
  name: 'GlassOptionForm',
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BFormFile,
    BCard,
    BCardText, 
    BMedia, 
    BImg,
    BOverlay,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BForm
  },
  directives: {
    Ripple,
  },
  data() {
      return {
          glass_types:[],
          loading:true,
          glassTypeChoices:[],
          currentBase64:null,
          currentBase642:null,
          file: null,
          file2: null,
          edition:false,
          form:{
            name:"",
            price:0,
            photo:null,
            icon:null,
            description:'',
            file:'',
            glass_types:null,
            transparent_only:false
          },
      }
  },
  props: ['glass_option', 'readOnly'],
  methods:{
    editPhoto() {
      this.file=null
    },
    async getGlassTypes() {
      
        let glass_types = await APIRequest.list('glass-types')
        this.glass_types=glass_types[0];
        this.glassTypeChoices=Utils.formatSelect(this.glass_types,'name','id')
    },
    fileAdded(event)
    {
      var reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = () => {
         
          let b64=reader.result.split(';')
          let type=b64[0]
          if(type.includes('image'))
          {
              let base64=b64[1]
              //base64.replace('base64,','')
              this.currentBase64=reader.result
              this.form.photo=this.currentBase64
          }
          else
          {
              this.file=null
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Ceci n'est pas une image !",
                  icon: 'AlertCircleIcon',
                  variant: 'warning',
                },
              })
          }
          
      };
    },
    fileAdded2(event)
    {
      var reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = () => {
         
          let b64=reader.result.split(';')
          let type=b64[0]
          if(type.includes('image'))
          {
              let base64=b64[1]
              //base64.replace('base64,','')
              this.currentBase642=reader.result
              this.form.icon=this.currentBase642
          }
          else
          {
              this.file2=null
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Ceci n'est pas une image !",
                  icon: 'AlertCircleIcon',
                  variant: 'warning',
                },
              })
          }
          
      };
    },
    editIcon() {
      this.file2=null
    },
    async createGlassOption()
    {
       this.$refs.simpleRules.validate().then(async success => {
        if (success) {
        this.loading=true
        try {

          var glass_types=this.form.glass_types
          this.form.glass_types=[]
          if(glass_types!=null)
          {
            for(var i=0;i<glass_types.length;i++)
            {
              
              this.form.glass_types[i]={}
              this.form.glass_types[i].id=glass_types[i].value
            }
          }
          delete this.form.tints;
          await APIRequest.create('glass-options',this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "L'option de verre a bien été créé !",
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({name:'glass-options'})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }

        }
       })
      
    },
    async updateGlassOption()
    {
       this.$refs.simpleRules.validate().then(async success => {
        if (success) {
      this.loading=true
        try {
          
          var glass_types=this.form.glass_types
          this.form.glass_types=[]
          if(glass_types!=null)
          {
            for(var i=0;i<glass_types.length;i++)
            {
              
              this.form.glass_types[i]={}
              this.form.glass_types[i].id=glass_types[i].value
            }
          }

          delete this.form.tints;

          await APIRequest.update('glass-options',this.glass_option.id,this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "L'option de verre a bien été modifiée !",
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({name:'glass-options'})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
        }
       })
      
    },
   

  },
  async mounted(){
  
    await this.getGlassTypes()
    if(this.glass_option!=null)
    {
      this.form=this.glass_option
      this.edition=true
      if(this.glass_option.photo!="")
      {
        this.file=this.glass_option.photo
      }
      if(this.glass_option.icon!="")
      {
        this.file2=this.glass_option.icon
      }

      if(this.glass_option.glass_types!=null)
      {
        for(let j=0;j<this.glass_option.glass_types.length;j++)
        {
          for(let i=0;i<this.glassTypeChoices.length;i++)
          {
            if(this.glass_option.glass_types[j].id == this.glassTypeChoices[i].value)
            {
              this.form.glass_types[j] = this.glassTypeChoices[i]
            }
          }
        }
      }
    }
    this.loading=false
  }

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>